import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Option from './_option';
import FieldSetting from './field-setting';
import './style.css';
var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);
  var _super = _createSuper(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _this.handleSelector = function (event) {
      if (_this.selector && !_this.selector.contains(event.target)) {
        _this.setState({
          isShowSelector: false
        });
      }
    };
    _this.getCurrentOption = function () {
      var _this$props = _this.props,
        value = _this$props.value,
        options = _this$props.options;
      var currentOption = value && options.find(function (option) {
        return option.value === value.value;
      });
      return currentOption;
    };
    _this.onSelectToggle = function (event) {
      var isShowSelector = _this.state.isShowSelector;
      var newValue = !isShowSelector;
      if (newValue) {
        _this.dropdownContainerHasInit = false;
      }
      _this.setState({
        isShowSelector: newValue
      });
    };
    _this.onChange = function (option) {
      _this.setState({
        isShowSelector: false,
        currentOption: option
      });
      _this.props.onChange(option);
    };
    _this.onUpdateOption = function (option) {
      _this.setState({
        currentOption: option
      });
      _this.props.onChange(option);
    };
    _this.setContainerRef = function (ref) {
      _this.dropdownContainer = ref;
    };
    _this.setSelectorRef = function (ref) {
      _this.selector = ref;
    };
    _this.state = {
      isShowSelector: false,
      currentOption: _this.getCurrentOption()
    };
    _this.dropdownContainerHasInit = false;
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleSelector);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleSelector);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var options = this.props.options;
      var currentOption = this.state.currentOption;
      var activeIndex = currentOption && options.findIndex(function (option) {
        return option.value === currentOption.value;
      });
      if (activeIndex > -1) {
        var scrollTop = 48 + (activeIndex + 1) * 32 - 150;
        if (scrollTop < 0) return;
        if (this.dropdownContainer && !this.dropdownContainerHasInit) {
          this.dropdownContainerHasInit = true;
          this.dropdownContainer.scrollTop = scrollTop;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        selectClass = _this$props2.selectClass,
        optionClass = _this$props2.optionClass,
        isSelected = _this$props2.isSelected,
        options = _this$props2.options,
        placeholder = _this$props2.placeholder;
      var _this$state = this.state,
        currentOption = _this$state.currentOption,
        isShowSelector = _this$state.isShowSelector;
      var isActive = isShowSelector || isSelected;
      return /*#__PURE__*/React.createElement("span", {
        ref: this.setSelectorRef,
        className: "select-container ".concat(selectClass || '')
      }, /*#__PURE__*/React.createElement("span", {
        className: "control-container ".concat(isActive ? 'active' : ''),
        onClick: this.onSelectToggle
      }, !currentOption && /*#__PURE__*/React.createElement("span", {
        className: "label placeholder"
      }, placeholder), currentOption && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "control-icon ".concat(currentOption.iconClass)
      }), /*#__PURE__*/React.createElement("span", {
        className: "control-label"
      }, currentOption.label)), /*#__PURE__*/React.createElement("span", {
        className: "operation"
      }, /*#__PURE__*/React.createElement("i", {
        className: "iconfont icon-drop-down arrow"
      }))), isShowSelector && /*#__PURE__*/React.createElement("span", {
        className: "select-popover"
      }, /*#__PURE__*/React.createElement(FieldSetting, {
        option: currentOption,
        onUpdateOption: this.onUpdateOption
      }), /*#__PURE__*/React.createElement("span", {
        className: "option-item-divider"
      }), /*#__PURE__*/React.createElement("span", {
        className: "option-item-wrapper",
        ref: this.setContainerRef
      }, options.map(function (option) {
        var isActive = option.value === (currentOption && currentOption.value);
        return /*#__PURE__*/React.createElement(Option, {
          key: option.value,
          optionClass: optionClass,
          isActive: isActive,
          option: option,
          onOptionChanged: _this2.onChange
        });
      }))));
    }
  }]);
  return Select;
}(React.Component);
export default Select;